import { IEpcPayment, IEpcQuotation, ISalesRepInfo } from "./epcCustomer.model";
import { IUserRef } from "./userData.model";

export enum IStatusCycle {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export interface ICommissionHistoryItem {
  _id?: string;
  customerId: {
    _id: string;
    customerName: string;
    mobileNumber: string;
  };
  proof?: string;
  quoteId: IEpcQuotation;
  commissionAmount: number;
  materialDeduction?: number;
  calculatedCommission: number;
  salesRepCommission: number;
  status: IStatusCycle;
  accountStatus?: IStatusCycle;
  cseId?: IUserRef;
  createdAt?: Date;
  adjustAmount?: number;
}

export interface ISalesRepCommission {
  _id?: string;
  cseApprovedAt?: Date | string;
  salesRepresentative: ISalesRepInfo;
  commissionHistory: ICommissionHistoryItem[];
  createdAt?: Date;
}
export interface ICommissionGroup {
  _id?: string;
  cseApprovedAt?: Date | string;
  salesRepresentative?: ISalesRepInfo;
  commissionHistory: ICommissionHistoryItem[];
}

export interface IRepaymentLog {
  remark: string;
  createdAt: Date;
}

export interface ICustomField {
  customFieldName: string;
  customFieldValue: number;
}

export interface IRepaymentHistoryItem {
  _id?: string;
  repaymentAmount: number;
  paymentAmount: number;
  fileCharge?: number;
  portalCharge?: number;
  totalPortalCharge?: number;
  plantSizeKW: number;
  cseStatus: IStatusCycle;
  accountStatus: IStatusCycle;
  appliedAt: Date | string;
  proof?: string;
  customFields?: ICustomField[];
  logs: IRepaymentLog[];
  cseApprovalDate?: Date;
  accountApprovalDate?: Date;
  cseUpdateDate?: Date;
  accountUpdateDate?: Date;
}

export interface IRepayment {
  _id: string;
  salesRep: ISalesRepInfo;
  payment: IEpcPayment;
  repaymentHistory: IRepaymentHistoryItem[];
  createdAt: string;
  updatedAt: string;
}
